import { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [status, setStatus] = useState({
    submitting: false,
    success: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, success: false, error: null });

    try {
      const messageContent = `
Naam: ${formData.name}<br />
E-mail: ${formData.email}<br />
Telefoon: ${formData.phone || 'Niet opgegeven'}<br/><br/>

Bericht:<br/>
${formData.message}
      `;

      // nginx (productie) of de Vite proxy (dev) voegt de API key toe
      const response = await fetch('/api/send-mail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: messageContent,
          title: '[iselda.nl] Mail via Contact formulier'
        })
      });

      if (response.status === 429) {
        throw new Error('Te veel verzoeken, probeer het over een minuut opnieuw');
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(`Fout bij verzenden: ${data.message || response.statusText}`);
      }

      if (data.status === 'message-send') {
        setStatus({ submitting: false, success: true, error: null });
        // Reset formulier na succesvol verzenden
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Onverwachte response van server');
      }
    } catch (error) {
      console.error('Fout bij verzenden:', error);
      console.error('Error details:', {
        name: error.name,
        message: error.message,
        stack: error.stack
      });
      setStatus({ submitting: false, success: false, error: error.message });
    }
  };

  return (
    <div className="max-w-4xl w-full px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-iselda-900 text-center">
        Neem contact op
      </h2>

      {status.success && (
        <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
          Bedankt voor je bericht!
          <br />
          Ik neem zo snel mogelijk contact met je op.
        </div>
      )}

      {status.error && (
        <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-sm">
          Er is iets misgegaan: {status.error}
        </div>
      )}

      {!status.success && (
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" className="block text-gray-800 mb-2">
              Naam <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-2 border border-iseldaAccent-400 rounded-lg bg-white"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-gray-800 mb-2">
              E-mailadres <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-2 border border-iseldaAccent-400 rounded-lg bg-white"
            />
          </div>

          <div>
            <label htmlFor="phone" className="block text-gray-800 mb-2">
              Telefoonnummer <span className="text-gray-500 text-sm">(optioneel)</span>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-2 border border-iseldaAccent-400 rounded-lg bg-white"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-gray-800 mb-2">
              Bericht <span className="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={4}
              className="w-full p-2 border border-iseldaAccent-400 rounded-lg bg-white"
            />
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={status.submitting}
              className={`bg-accent hover:bg-accent-hover text-accent-text font-bold py-4 px-8 sm:py-3 sm:px-6 rounded-full text-lg min-h-[44px] ${
                status.submitting ? 'opacity-70 cursor-not-allowed' : ''
              }`}
            >
              {status.submitting ? 'Versturen...' : 'Verstuur'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Contact;
